var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 131,
    viewBox: "0 0 130 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_62_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.6453,
    width: 90,
    height: 90,
    rx: 45,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8333 44.9786H45.1667C44.7065 44.9786 44.3333 45.3517 44.3333 45.8119V77.4786C44.3333 77.9388 44.7065 78.3119 45.1667 78.3119C45.6269 78.3119 46 77.9388 46 77.4786V46.6453H76V76.6453H48.5C48.0398 76.6453 47.6667 77.0184 47.6667 77.4786C47.6667 77.9388 48.0398 78.3119 48.5 78.3119H76.8333C77.2935 78.3119 77.6667 77.9388 77.6667 77.4786V45.8119C77.6667 45.3517 77.2935 44.9786 76.8333 44.9786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 43.3119C56.4602 43.3119 56.8333 42.9388 56.8333 42.4786V39.9786H65.3203C65.6655 40.9466 66.5818 41.6453 67.6667 41.6453C69.0454 41.6453 70.1667 40.524 70.1667 39.1453C70.1667 37.7665 69.0454 36.6453 67.6667 36.6453C66.5818 36.6453 65.6651 37.3439 65.3203 38.3119H56C55.5398 38.3119 55.1667 38.6851 55.1667 39.1453V42.4786C55.1667 42.9388 55.5398 43.3119 56 43.3119ZM67.6667 38.3119C68.1261 38.3119 68.5 38.6858 68.5 39.1453C68.5 39.6047 68.1261 39.9786 67.6667 39.9786C67.2072 39.9786 66.8333 39.6047 66.8333 39.1453C66.8333 38.6858 67.2072 38.3119 67.6667 38.3119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 79.1453C68.8731 79.1453 68.5 79.5184 68.5 79.9786V83.3119H60.0131C59.6682 82.3439 58.7515 81.6453 57.6667 81.6453C56.2879 81.6453 55.1667 82.7665 55.1667 84.1453C55.1667 85.524 56.2879 86.6453 57.6667 86.6453C58.7515 86.6453 59.6682 85.9466 60.0131 84.9786H69.3333C69.7935 84.9786 70.1667 84.6055 70.1667 84.1453V79.9786C70.1667 79.5184 69.7935 79.1453 69.3333 79.1453ZM57.6667 84.9786C57.2072 84.9786 56.8333 84.6047 56.8333 84.1453C56.8333 83.6858 57.2072 83.3119 57.6667 83.3119C58.1261 83.3119 58.5 83.6858 58.5 84.1453C58.5 84.6047 58.1261 84.9786 57.6667 84.9786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3333 64.2986V54.9783C84.3333 54.5181 83.9602 54.145 83.5 54.145H80.1667C79.7065 54.145 79.3333 54.5181 79.3333 54.9783C79.3333 55.4385 79.7065 55.8116 80.1667 55.8116H82.6667V64.2986C81.6987 64.6435 81 65.5601 81 66.645C81 68.0237 82.1212 69.145 83.5 69.145C84.8788 69.145 86 68.0237 86 66.645C86 65.5601 85.3013 64.6435 84.3333 64.2986ZM83.5 67.4783C83.0405 67.4783 82.6667 67.1044 82.6667 66.645C82.6667 66.1855 83.0405 65.8116 83.5 65.8116C83.9594 65.8116 84.3333 66.1855 84.3333 66.645C84.3333 67.1044 83.9594 67.4783 83.5 67.4783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 67.4786H39.3333V58.9916C40.3013 58.6468 41 57.7301 41 56.6453C41 55.2665 39.8788 54.1453 38.5 54.1453C37.1212 54.1453 36 55.2665 36 56.6453C36 57.7301 36.6987 58.6464 37.6667 58.9916V68.3119C37.6667 68.7721 38.0398 69.1453 38.5 69.1453H42.6667C43.1269 69.1453 43.5 68.7721 43.5 68.3119C43.5 67.8517 43.1269 67.4786 42.6667 67.4786ZM38.5 55.8119C38.9594 55.8119 39.3333 56.1858 39.3333 56.6453C39.3333 57.1047 38.9594 57.4786 38.5 57.4786C38.0406 57.4786 37.6667 57.1047 37.6667 56.6453C37.6667 56.1858 38.0406 55.8119 38.5 55.8119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 61.6453V71.6453C53.5 72.1055 53.8731 72.4786 54.3333 72.4786C54.7935 72.4786 55.1667 72.1055 55.1667 71.6453V61.6453C55.1667 61.1851 54.7935 60.8119 54.3333 60.8119C53.8731 60.8119 53.5 61.1851 53.5 61.6453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1667 58.3119V71.6453C60.1667 72.1055 60.5398 72.4786 61 72.4786C61.4602 72.4786 61.8333 72.1055 61.8333 71.6453V58.3119C61.8333 57.8517 61.4602 57.4786 61 57.4786C60.5398 57.4786 60.1667 57.8517 60.1667 58.3119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8333 63.3119V71.6453C66.8333 72.1055 67.2065 72.4786 67.6667 72.4786C68.1269 72.4786 68.5 72.1055 68.5 71.6453V63.3119C68.5 62.8517 68.1269 62.4786 67.6667 62.4786C67.2065 62.4786 66.8333 62.8517 66.8333 63.3119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4229 50.2224C72.0974 49.8969 71.5702 49.8969 71.2443 50.2224L65.0279 56.4389L59.747 53.4214C59.4591 53.2558 59.0993 53.2781 58.8337 53.4783L52.167 58.4783C51.7987 58.7543 51.7243 59.2766 52.0007 59.6449C52.1641 59.863 52.4144 59.9783 52.6678 59.9783C52.8415 59.9783 53.0167 59.9243 53.167 59.8116L59.3954 55.1405L64.7533 58.2019C65.0814 58.3894 65.491 58.334 65.7559 58.0676L72.4226 51.4009C72.7485 51.0754 72.7485 50.5479 72.4229 50.2224L72.4229 50.2224Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_62_2",
    x: 0,
    y: 0.645264,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.929412 0 0 0 0 0.933333 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_2",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechIcon);
export default __webpack_public_path__ + "static/media/tech-icon.460545555afa55e551c350649092c70c.svg";
export { ForwardRef as ReactComponent };